/**
 * @generated SignedSource<<77669da94e78394a37ccafa7d6b4e72a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ScriptTagSettingTabContainer_ActivateUserTagVersionMutation$variables = {
  versionId: string;
};
export type ScriptTagSettingTabContainer_ActivateUserTagVersionMutationVariables = ScriptTagSettingTabContainer_ActivateUserTagVersionMutation$variables;
export type ScriptTagSettingTabContainer_ActivateUserTagVersionMutation$data = {
  readonly activateUserTagVersion: {
    readonly site: {
      readonly " $fragmentSpreads": FragmentRefs<"ScriptTagSettingTabContainer_site">;
    };
    readonly userTagVersion: {
      readonly id: string;
      readonly versionName: string;
      readonly isActive: boolean;
      readonly content: string;
      readonly createdAt: string;
    };
  } | null;
};
export type ScriptTagSettingTabContainer_ActivateUserTagVersionMutationResponse = ScriptTagSettingTabContainer_ActivateUserTagVersionMutation$data;
export type ScriptTagSettingTabContainer_ActivateUserTagVersionMutation = {
  variables: ScriptTagSettingTabContainer_ActivateUserTagVersionMutationVariables;
  response: ScriptTagSettingTabContainer_ActivateUserTagVersionMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "versionId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "versionId",
        "variableName": "versionId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "versionName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "UserTagVersion",
  "kind": "LinkedField",
  "name": "userTagVersion",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "versionNumber",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tagContent",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authorName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priority",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPendingChanges",
  "storageKey": null
},
v18 = [
  (v2/*: any*/),
  (v14/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v20 = [
  (v2/*: any*/),
  (v19/*: any*/)
],
v21 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
],
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "Page",
  "kind": "LinkedField",
  "name": "page",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Funnel",
      "kind": "LinkedField",
      "name": "funnel",
      "plural": false,
      "selections": (v18/*: any*/),
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "storageKey": null
},
v23 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "moduleName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fromLabel",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "toLabel",
    "storageKey": null
  }
],
v24 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "codeDraftModuleNames",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "addedModuleNames",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "removedModuleNames",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "UserTagToggleChange",
    "kind": "LinkedField",
    "name": "toggleChanges",
    "plural": true,
    "selections": (v23/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "UserTagToggleChange",
    "kind": "LinkedField",
    "name": "linkChanges",
    "plural": true,
    "selections": (v23/*: any*/),
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ScriptTagSettingTabContainer_ActivateUserTagVersionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ActivateUserTagVersionPayload",
        "kind": "LinkedField",
        "name": "activateUserTagVersion",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Site",
            "kind": "LinkedField",
            "name": "site",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ScriptTagSettingTabContainer_site"
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ScriptTagSettingTabContainer_ActivateUserTagVersionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ActivateUserTagVersionPayload",
        "kind": "LinkedField",
        "name": "activateUserTagVersion",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Site",
            "kind": "LinkedField",
            "name": "site",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "embedTag",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "robeeTag",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userTagDraft",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTagModule",
                "kind": "LinkedField",
                "name": "userTagPublishedModule",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTagModule",
                "kind": "LinkedField",
                "name": "userTagModules",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v6/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "draftContent",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "draftEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasDraft",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPendingToggle",
                    "storageKey": null
                  },
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "effectiveEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDistributionGated",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDraftDistributionGated",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPendingLinkChange",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isArchive",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deletedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PopupGroup",
                    "kind": "LinkedField",
                    "name": "popupGroups",
                    "plural": true,
                    "selections": (v18/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AbtestScenarioPageGroup",
                    "kind": "LinkedField",
                    "name": "abtestScenarioPageGroups",
                    "plural": true,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PopupGroup",
                    "kind": "LinkedField",
                    "name": "draftPopupGroups",
                    "plural": true,
                    "selections": (v18/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AbtestScenarioPageGroup",
                    "kind": "LinkedField",
                    "name": "draftAbtestScenarioPageGroups",
                    "plural": true,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v21/*: any*/),
                "concreteType": "PopupGroupConnection",
                "kind": "LinkedField",
                "name": "popupGroups",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PopupGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PopupGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v14/*: any*/),
                          (v22/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "popupGroups(first:500)"
              },
              {
                "alias": null,
                "args": (v21/*: any*/),
                "concreteType": "AbtestScenarioPageGroupConnection",
                "kind": "LinkedField",
                "name": "abtestScenarioPageGroups",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AbtestScenarioPageGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AbtestScenarioPageGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v19/*: any*/),
                          (v22/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "abtestScenarioPageGroups(first:500)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTagModule",
                "kind": "LinkedField",
                "name": "enabledUserTagModules",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mergedTagPreview",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "draftMergedTagPreview",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enabledModuleCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalModuleCount",
                "storageKey": null
              },
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasWorkspaceDeployDrift",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTagWorkspacePendingChangeSummary",
                "kind": "LinkedField",
                "name": "userTagWorkspacePendingChangeSummary",
                "plural": false,
                "selections": (v24/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTagVersion",
                "kind": "LinkedField",
                "name": "userTagVersions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v4/*: any*/),
                  (v6/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserTagWorkspacePendingChangeSummary",
                    "kind": "LinkedField",
                    "name": "changeSummary",
                    "plural": false,
                    "selections": (v24/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserTagVersionModuleSnapshot",
                    "kind": "LinkedField",
                    "name": "modulesSnapshot",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "moduleId",
                        "storageKey": null
                      },
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "gated",
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTagVersion",
                "kind": "LinkedField",
                "name": "activeUserTagVersion",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v4/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e76c6fe209f15ed397c17a3010b37f91",
    "id": null,
    "metadata": {},
    "name": "ScriptTagSettingTabContainer_ActivateUserTagVersionMutation",
    "operationKind": "mutation",
    "text": "mutation ScriptTagSettingTabContainer_ActivateUserTagVersionMutation(\n  $versionId: ID!\n) {\n  activateUserTagVersion(input: {versionId: $versionId}) {\n    site {\n      ...ScriptTagSettingTabContainer_site\n      id\n    }\n    userTagVersion {\n      id\n      versionName\n      isActive\n      content\n      createdAt\n    }\n  }\n}\n\nfragment ScriptTagSettingTabContainer_site on Site {\n  id\n  embedTag\n  robeeTag\n  userTagDraft\n  userTagPublishedModule {\n    id\n    versionNumber\n    tagContent\n    status\n    description\n    authorName\n    publishedAt\n    createdAt\n  }\n  userTagModules {\n    id\n    versionNumber\n    tagContent\n    status\n    description\n    authorName\n    publishedAt\n    createdAt\n    name\n    enabled\n    priority\n    draftContent\n    draftEnabled\n    hasDraft\n    hasPendingToggle\n    hasPendingChanges\n    effectiveEnabled\n    isDistributionGated\n    isDraftDistributionGated\n    hasPendingLinkChange\n    isArchive\n    deletedAt\n    popupGroups {\n      id\n      name\n    }\n    abtestScenarioPageGroups {\n      id\n      title\n    }\n    draftPopupGroups {\n      id\n      name\n    }\n    draftAbtestScenarioPageGroups {\n      id\n      title\n    }\n  }\n  popupGroups(first: 500) {\n    edges {\n      node {\n        id\n        name\n        page {\n          funnel {\n            id\n            name\n          }\n          id\n        }\n      }\n    }\n  }\n  abtestScenarioPageGroups(first: 500) {\n    edges {\n      node {\n        id\n        title\n        page {\n          funnel {\n            id\n            name\n          }\n          id\n        }\n      }\n    }\n  }\n  enabledUserTagModules {\n    id\n    name\n    enabled\n    priority\n    tagContent\n  }\n  mergedTagPreview\n  draftMergedTagPreview\n  enabledModuleCount\n  totalModuleCount\n  hasPendingChanges\n  hasWorkspaceDeployDrift\n  userTagWorkspacePendingChangeSummary {\n    codeDraftModuleNames\n    addedModuleNames\n    removedModuleNames\n    toggleChanges {\n      moduleName\n      fromLabel\n      toLabel\n    }\n    linkChanges {\n      moduleName\n      fromLabel\n      toLabel\n    }\n  }\n  userTagVersions {\n    id\n    versionName\n    description\n    authorName\n    isActive\n    createdAt\n    content\n    changeSummary {\n      codeDraftModuleNames\n      addedModuleNames\n      removedModuleNames\n      toggleChanges {\n        moduleName\n        fromLabel\n        toLabel\n      }\n      linkChanges {\n        moduleName\n        fromLabel\n        toLabel\n      }\n    }\n    modulesSnapshot {\n      moduleId\n      name\n      enabled\n      priority\n      gated\n      tagContent\n    }\n  }\n  activeUserTagVersion {\n    id\n    versionName\n    description\n    authorName\n    isActive\n    createdAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "d73d308ed09d4032d6684e0cf2f500d9";

export default node;
